module.exports = __webpack_public_path__ + "static/media/arrowUp.9bc0ef19.svg";